import React from 'react';
import PropTypes from 'prop-types';
import Carousel from 'nuka-carousel';
import {urls} from '../config';
import {cdnResize, objectToQueryString} from '../services/utils';
import classNames from 'classnames';
import AppFeatures from '../components/App-features';
import {execBI} from '../services/bi-events-manager';
import {FormattedMessage, intlShape, injectIntl} from 'react-intl';
import injectMain from '../services/inject-main';

const socialShare = (network, app, formatMessage, fullUrl) => {
  return (ev) => {
    ev.preventDefault();

    const title = formatMessage({id: 'application.share.title'}, {application: app.name});
    const text = app.teaser;
    const url = `${fullUrl}/${app.slug}/overview`;

    const shareUrl = (network === 'twitter' ? urls.shareTwitter : urls.shareFacebook)
      .replace('{title}', encodeURIComponent(title))
      .replace('{text}', encodeURIComponent(text))
      .replace('{url}', encodeURIComponent(url));

    window.open(shareUrl, '_blank', 'location=yes,height=440,width=520,scrollbars=yes,status=yes');
    execBI('SOCIAL_SHARE', {appDefinitionId: app.appDefinitionId, type: network});
  };
};

class Slider extends React.Component {
  render() {
    const pictures = this.props.pictures;

    class Points extends React.Component {
      render() {
        return (
          <div className="slider-points">
            {pictures.map((i, k) =>
              <a key={k} className={classNames('sl-po', {'sl-po-a': k === this.props.currentSlide})} onClick={() => this.props.goToSlide(k)}></a>
            )}
          </div>
        );
      }
      static propTypes = {
        goToSlide: PropTypes.func,
        currentSlide: PropTypes.number
      };
    }

    const Dec = [{
      component: Points,
      position: 'BottomLeft'
    }];

    return (
      <div className="carousel slider-app-overview">
        <Carousel autoplay autoplayInterval={7000} speed={1200} easing="easeOutQuad" wrapAround decorators={Dec}>
          {pictures.map(pic =>
            <img
              key={pic}
              src={cdnResize(pic, 500, 360)}
              width="500"
              />
          )}
        </Carousel>
      </div>
    );
  }

  static propTypes = {
    pictures: PropTypes.array
  }
}



class _OverviewTab extends React.Component {
  render() {
    const app = this.props.app;
    const {formatMessage} = this.props.intl;

    return (
      <div className="app-tab-overview tab-content-pad">
        <Slider pictures={app.pictures}/>

        <div className="text-container">
          <div className="cms-text-content">
            {this.props.market === 'standalone' ?
              <h3 className="second-title">
                <span className="second-title-text">{app.name}</span>
                <a title="Share on Twitter" href="#" className="button-icon-twitter" onClick={socialShare('twitter', app, formatMessage, this.props.fullUrl)}></a>
                <a title="Share on Facebook" href="#" className="button-icon-facebook" onClick={socialShare('facebook', app, formatMessage, this.props.fullUrl)}></a>
              </h3> : null}
            <div className="app-description" dangerouslySetInnerHTML={{__html: app.description}}></div>
          </div>
        </div>
        <br className="clear"/>
      </div>
    );
  }

  static propTypes = {
    app: PropTypes.object.isRequired,
    intl: intlShape.isRequired,
    market: PropTypes.string,
    fullUrl: PropTypes.string
  }
}
const OverviewTab = injectMain(injectIntl(_OverviewTab));


class DemoTab extends React.Component {
  render() {
    const app = this.props.app;
    return (
      <div className="app-tab-demo tab-content-pad">
        <iframe src={app.liveDemoUrl} width="100%" height="100%" frameBorder="0"></iframe>
      </div>
    );
  }
  static propTypes = {
    app: PropTypes.object.isRequired
  }
}

class _ReviewsTab extends React.Component {
  constructor(props) {
    super(props);
    this.state = {url: undefined};
  }

  componentDidMount() {
    const loggedIn = this.props.market !== 'standalone' || window.W.Site.Common.UserDetailsServer.isSessionValid() ? '1' : '0';
    const app = this.props.app;

    const params = {appDefinitionId: app.appDefinitionId, loggedIn, slug: app.slug, name: encodeURIComponent(app.name)};
    this.setState({url: `${urls.reviewsPublicWindow}?${objectToQueryString(params)}`});
  }

  render() {
    return (
      <div className="reviews-public-window">
        {this.state.url ? <iframe src={this.state.url} width="100%" height="100%"></iframe> : null}
      </div>
    );
  }
  static propTypes = {
    app: PropTypes.object.isRequired,
    market: PropTypes.string
  }
}

const ReviewsTab = injectMain(_ReviewsTab);

class DeveloperTab extends React.Component {
  render() {
    const app = this.props.app;
    return (
      <div className="app-developer-info tab-content-pad">
        <div className="app-developer-info-content">

          {app.supportInfo.supportUrl || app.supportInfo.supportMail || app.supportInfo.supportPhone ?
            <div className="support-info">
              <h3 className="typography_t2"><FormattedMessage id="application.tabs.developer-info.supportInfo.header"/></h3>

              {app.supportInfo.supportMail ?
                <p className="support-email typography_t4_3">
                  <span className="icon"><span><FormattedMessage id="application.tabs.developer-info.supportInfo.email"/>:</span></span>
                  <a href={`mailto:${app.supportInfo.supportMail}`} onClick={() => execBI('APP_MODAL_SUPPORT_INFO_CLICK', {infoType: 'email'})}>{app.supportInfo.supportMail}</a>
                </p> : null}

              {app.supportInfo.supportUrl ?
                <p className="support-url typography_t4_3">
                  <span className="icon"><span><FormattedMessage id="application.tabs.developer-info.supportInfo.website"/>:</span></span>
                  <a href={app.supportInfo.supportUrl} target="_blank" rel="noopener" onClick={() => execBI('APP_MODAL_SUPPORT_INFO_CLICK', {infoType: 'website'})}>Developer Website</a>
                </p> : null }

              {app.supportInfo.supportPhone ?
                <p className="support-phone typography_t4_3">
                  <span className="icon"><span><FormattedMessage id="application.tabs.developer-info.supportInfo.phone"/>:</span></span>
                  <a onClick={() => execBI('APP_MODAL_SUPPORT_INFO_CLICK', {infoType: 'phone'})}>{app.supportInfo.supportPhone}</a>
                </p> : null }
            </div> : null}

          <div className="text-container">
            <div className="cms-text-content">
              <h3>
                <span><FormattedMessage id="application.tabs.developer-info.thisAppWasMadeBy"/> </span>
                <a href={app.companyWebsite} target="_blank" rel="noopener" onClick={() => execBI('APP_MODAL_DEV_NAME_CLICK', {origin: 'dev_info'})}>{app.by}</a>
              </h3>
              {app.by !== 'Wix' ?
                <h4 className="title-partner"><FormattedMessage id="application.tabs.developer-info.wixAppMarketPartner"/></h4> : null }
              <div className="developer-info-text" dangerouslySetInnerHTML={{__html: app.developerInfo}}></div>
            </div>
          </div>

          <br className="clear"/>
        </div>
      </div>
    );
  }
  static propTypes = {
    app: PropTypes.object.isRequired
  }
}


export default class AppPageTabs extends React.Component {
  static renderTab(tabName, app) {
    switch (tabName) {
      default:
      case 'overview':
        return <OverviewTab app={app}/>;
      case 'demo':
        return <DemoTab app={app}/>;
      case 'features':
        return <AppFeatures app={app}/>;
      case 'reviews':
        return <ReviewsTab app={app}/>;
      case 'developer':
        return <DeveloperTab app={app}/>;
    }
  }

  render() {
    const {app, tabUrl} = this.props;
    return (
      <div className={classNames('tab-content', `tab-content-${tabUrl}`)}>
        <div className="tab-pane">
          <div className="tab-content-inner">
            {AppPageTabs.renderTab(tabUrl, app)}
          </div>
        </div>
      </div>
    );
  }

  static propTypes = {
    app: PropTypes.object,
    tabUrl: PropTypes.string
  }
}



// WEBPACK FOOTER //
// ./components/App-page-tabs.js